import environmentFunction from "./environment.dev";

export const environment = environmentFunction("oscar");
